import React from 'react'

import axios from 'axios'
import { DateTime } from 'luxon'

const apiUrl = "https://app-558a89a4-7ab5-4ec8-a7b9-b45fa70f1fe4.cleverapps.io"

const CommentAPI = {
  fetchThread: function(threadId) {
    return axios.get(`${apiUrl}/api/comments`, {params: {threadId}}).then(res => res.data)
  },
  postComment: function(threadId, data) {
    return axios.post(`${apiUrl}/api/comments`, data, {params: {threadId}})
  }
}

class CommentForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {submitted: false, error: false};
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  render() {
    return <form onSubmit={this.handleSubmit}>
      <label htmlFor="author">Nom :</label><br/>
      <input type="text" id="author" name="author" required /><br/>
      <label htmlFor="email">Adresse email (facultatif) :</label><br/>
      <input type="email" id="email" name="email" /><br />
      <label htmlFor="comment">Commentaire :</label><br/>
      <textarea id="comment" name="comment" minLength="3" rows="5" cols="33" required /><br/>
      {this.state.submitted && <div style={{color: "green", fontSize: "small"}}>
        Votre commentaire a été reçu et sera affiché après validation.
      </div>}
      {this.state.error && <div style={{color: "red", fontSize: "small"}}>
        Une erreur est survenue, veuillez réessayer.
      </div>}
      <input type="submit" value="Envoyer"/>
    </form>
  }

  handleSubmit(e) {
    e.preventDefault();
    const target = e.target;
    this.setState({submitted: false, error: false});
    const formData = new FormData(target);
    CommentAPI.postComment(this.props.threadId, {
                author: formData.get("author"),
                email: formData.get("email"),
                comment: formData.get("comment")
              })
              .then(_ => {
                target.reset();
                this.setState({submitted: true})
              })
              .catch(err => {
                console.log(err);
                this.setState({error: true})
              });
  };
}

function Comment({author, postedOn, comment}) {
  return <div>
    <div>Par <strong>{author}</strong> le <strong>{DateTime.fromISO(postedOn).setLocale('fr').toLocaleString(DateTime.DATETIME_FULL)}</strong></div>
    <div style={{whiteSpace: "pre-line"}}>{comment}</div>
  </div>
}

class Comments extends React.Component {
  constructor(props) {
    super(props);
    this.state = {comments: null};
  }
  componentDidMount() {
    CommentAPI
      .fetchThread(this.props.threadId)
      .then(data => this.setState({comments: data}))
      .catch(err => console.log(err));
  }
  render() {
    return (this.state.comments && <div>
        <h4>Commentaires ({this.state.comments.length})</h4>
        <ul>{this.state.comments.map(data => <li key={data.id}><Comment {...data}/></li>)}</ul>
        <CommentForm threadId={this.props.threadId}/>
    </div>)
  }
}

export default Comments
